import Toast from 'mint-ui/lib/toast';
import 'mint-ui/lib/toast/style.css';

function _Toast(message, duration = 1500) {
  Toast({
    message,
    duration
  });
}

export default _Toast;
